import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { scrollToForm } from '../utils/scroll';
type Tone = 'champagne' | 'ink' | 'outline';
interface CtaButtonProps {
  label: string;
  tone?: Tone;
  size?: 'sm' | 'md';
  className?: string;
}
const toneClasses: Record<Tone, string> = {
  champagne: 'bg-champagne text-ink hover:bg-champagne-light focus-visible:outline-champagne',
  ink: 'bg-ink text-ivory hover:bg-ink-700 focus-visible:outline-ink',
  outline: 'border border-ivory/40 text-ivory hover:border-champagne hover:text-champagne focus-visible:outline-champagne'
};
export function CtaButton({
  label,
  tone = 'champagne',
  size = 'md',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'sm' ? 'px-5 py-3 text-[11px] tracking-[0.18em]' : 'px-8 py-4 sm:py-5 text-xs tracking-[0.2em]';
  return <button type="button" onClick={scrollToForm} className={`group inline-flex items-center justify-center gap-3 font-sans font-medium uppercase transition-colors duration-200 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${toneClasses[tone]} ${sizing} ${className}`} data-id="element-59" data-mp="19bbg3v0fb1dz">
      <span data-id="element-60" data-mp="3ey4281lqj5n6">{label}</span>
      <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-61" data-mp="3ewsyg1sahxw2" />
    </button>;
}